import classNames from 'classnames';
import React from 'react';
import { useUser } from '../../../../hooks/use_user';
import { WebAnalytics } from '../../../../lib/web_analytics';
import { RoutePaths } from '../../../../routes';
import { OmniaButton } from '../../../omnia_button/omnia_button';
import { OmniaLink } from '../../../omnia_link/omnia_link';
import { SpanLink } from '../../../span_link/span_link';
import SvgOmniaProLogo from '../../../svg/omnia_pro_logo';
import proImg from './proPhoneLaptopImage.png';
import styles from './upgrade_card.less';
interface UpgradeCardProps {
  onLockedLayerClick: (isTrial?: boolean) => void;
}
export const UpgradeCard = (props: UpgradeCardProps) => {
  const { isPro } = useUser();
  const { onLockedLayerClick } = props;

  return (
    <>
      {!isPro && (
        <section className={classNames(styles.upgradeSection, 'pt-3 pl-3')}>
          <div className="flex overflow-hidden">
            <div className="w-1/2 pb-3">
              <OmniaLink
                to={RoutePaths.PREMIUM_PRO}
                className="py-1 px-2 border border-solid border-[#fff] block w-fit rounded-xl mb-2"
                onClick={() => {
                  WebAnalytics.proButtonClicked({
                    location: 'map_layers_panel',
                    type: 'learn_more',
                    style: 'logo',
                  });
                }}
              >
                <SvgOmniaProLogo />
              </OmniaLink>
              <span className="text-[#fff]">
                Unlock additional map layers with Omnia PRO or{' '}
                <SpanLink
                  onClick={() => {
                    onLockedLayerClick(true);
                    WebAnalytics.proButtonClicked({
                      location: 'map_layers_panel',
                      type: 'trial',
                      style: 'link',
                    });
                  }}
                  underline
                  className="text-[#fff] hover:text-[#fff] focus:text-[#fff] mb-2 block mr-2.5"
                >
                  start a 7-Day FREE Trial
                </SpanLink>
              </span>
              <OmniaButton
                onPress={() => {
                  onLockedLayerClick();
                  WebAnalytics.proButtonClicked({
                    location: 'map_layers_panel',
                    type: 'purchase',
                    style: 'button',
                  });
                }}
                kind="primary"
                size="md"
              >
                Join PRO
              </OmniaButton>
            </div>
            <div className="w-1/2 -mr-2">
              <img src={proImg} alt="" className="transform translate-y-1.5 w-[193px] h-[145px]" />
            </div>
          </div>
        </section>
      )}
    </>
  );
};
